import * as React from "react";
import { LobSubtitleProps, SubtitleProps } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkSubheading } from "uitk-react-text";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewExtraLarge } from "@shared-ui/viewport-context";

const Subtitle: React.FunctionComponent<SubtitleProps> = ({ text, className }) => (
  <div className={className} data-testid="lobsubtitle">
    <UitkSubheading>{text}</UitkSubheading>
  </div>
);

export const LobSubtitle: React.FunctionComponent<LobSubtitleProps> = ({ lobState, className, customSubTitle }) => {
  const { formatText } = useLocalization();
  const text =
    customSubTitle ||
    formatText(lobState.config.heading.locSubtitleTextToken, lobState.config.heading.locSubtitleVariant);
  const breakpointMode = lobState.config.heading.lobSubtitleBreakPoint || "off";

  if (breakpointMode === "off") {
    return null;
  }

  return (
    <Viewport>
      {
        {
          on: (
            <ViewSmall>
              <Subtitle text={text} className={className} />
            </ViewSmall>
          ),
          small: (
            <ViewSmall>
              <Subtitle text={text} className={className} />
            </ViewSmall>
          ),
          medium: (
            <ViewMedium>
              <Subtitle text={text} className={className} />
            </ViewMedium>
          ),
          large: (
            <ViewLarge>
              <Subtitle text={text} className={className} />
            </ViewLarge>
          ),
          "extra-large": (
            <ViewExtraLarge>
              <Subtitle text={text} />
            </ViewExtraLarge>
          ),
        }[breakpointMode]
      }
    </Viewport>
  );
};
